/** Customer-facing occasion labels (snake_case DB → readable copy). */
export function humaniseOccasion(occasion: string): string {
  if (occasion === "work_anniversary") return "work anniversary";
  if (occasion === "welcome") return "first day";
  if (occasion === "farewell") return "farewell";
  if (occasion === "milestone") return "milestone";
  if (occasion === "birthday") return "birthday";
  return occasion.replace(/_/g, " ");
}

/** Shorter label for possessive headers ("Sarah's anniversary"). */
export function humaniseOccasionShort(occasion: string): string {
  if (occasion === "work_anniversary") return "anniversary";
  if (occasion === "welcome") return "first day";
  if (occasion === "farewell") return "farewell";
  if (occasion === "milestone") return "milestone";
  if (occasion === "birthday") return "birthday";
  return occasion.replace(/_/g, " ");
}
